import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

interface NotesModalProps {
  show: boolean
  onHide: () => void
  notes: string
  onNotesChange: (notes: string) => void
  onSave: () => void
}

const NotesModal: React.FC<NotesModalProps> = ({show, onHide, notes, onNotesChange, onSave}) => {
  const handleSave = () => {
    onSave()
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} centered size='lg' aria-labelledby='notes-modal'>
      <Modal.Header closeButton>
        <Modal.Title id='notes-modal'>Add Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <textarea
          className='form-control'
          rows={3}
          placeholder='Add notes for this time entry...'
          value={notes}
          maxLength={1024}
          onChange={(e) => onNotesChange(e.target.value)}
          autoFocus
        />
        <div className='text-end text-muted small mt-1'>{notes.length}/1024 characters</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-secondary' onClick={onHide}>
          Cancel
        </Button>
        <Button className='bg-primary' onClick={handleSave}>
          Save Notes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NotesModal
